import React from 'react'
import { Typography } from '@material-ui/core'
import { RequestInfoForm } from 'src/app/components/forms'

export const HomePage: React.FC = () => (
  <>
    <Typography variant="body1" gutterBottom>
      This Consumer Request Submission is intended for individuals who are making a request pursuant to the California Consumer Privacy Act (CCPA). The information provided in this form will be used to verify your identity and to fulfill your request. If the information
      provided in this form is insufficient to verify your identity or accurately respond to your request, we may contact you to request additional clarification and detail.
    </Typography>
    <br />
    <Typography variant="body1" gutterBottom>
      If you are submitting this request on behalf of someone else, as an authorized agent, your identity and authority will also need to be verified. We will respond to your request consistent with applicable laws.
    </Typography>
    <br />
    <Typography variant="body1" gutterBottom>
      If you have multiple relationships and account types with SAFE, a separate request must be submitted for each inquiry.
    </Typography>
    <RequestInfoForm />
  </>
)

export default HomePage
